export const textFieldType = {
  S: 'SMALL',
  M: 'MEDIUM',
};
